module.exports = __webpack_public_path__ + "img/cooperation09.a7b61412.png";